/**
 * Enable sending language field information to Zendesk
 */
export const HELP_CENTER_LANGUAGE_FIELD_ENABLE =
  'HELP_CENTER_LANGUAGE_FIELD_ENABLE';
